import {
  Box,
  Spinner as ChakraUISpinner,
  type SpinnerProps as ChakraUISpinnerProps
} from "@chakra-ui/react";

import type { ReactNode } from "react";

export interface SpinnerProps {
  label?: string;
  size?: ChakraUISpinnerProps["size"] | string;
  emptyColor?: string;
  speed?: string | number;
  thickness?: string | number;
  color?: string;
  colorPalette?: string;
  children?: ReactNode;
}

export function Spinner(props: SpinnerProps) {
  const {
    children,
    label,
    emptyColor,
    speed,
    thickness,
    color,
    colorPalette,
    ...rest
  } = props;

  const spinnerProps = {
    ...rest,
    "aria-label": label,
    color: color ?? colorPalette,
    css: {
      ...(emptyColor ? { "--spinner-track-color": emptyColor } : {}),
      ...(speed ? { animationDuration: String(speed) } : {}),
      ...(thickness ? { borderWidth: String(thickness) } : {})
    }
  } as ChakraUISpinnerProps;

  if (children) {
    return (
      <Box position="relative" w="full" maxW="full">
        <ChakraUISpinner
          {...spinnerProps}
          position="absolute"
          top="50%"
          left="50%"
          display="block"
        />
        <Box
          w="full"
          maxW="full"
          opacity={0.5}
          userSelect="none"
          pointerEvents="none"
        >
          {children}
        </Box>
      </Box>
    );
  }
  return <ChakraUISpinner {...spinnerProps} />;
}
